import { render, staticRenderFns } from "./supplierApproval.vue?vue&type=template&id=186d363d&scoped=true"
import script from "./supplierApproval.vue?vue&type=script&lang=js"
export * from "./supplierApproval.vue?vue&type=script&lang=js"
import style0 from "./supplierApproval.vue?vue&type=style&index=0&id=186d363d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186d363d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('186d363d')) {
      api.createRecord('186d363d', component.options)
    } else {
      api.reload('186d363d', component.options)
    }
    module.hot.accept("./supplierApproval.vue?vue&type=template&id=186d363d&scoped=true", function () {
      api.rerender('186d363d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/supplierManage/supplierApproval.vue"
export default component.exports